// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_gb-3";
export var flatBottomCorners = "_gb-5";
export var productImage = "_gb-0";
export var quantityContainer = "_gb-2";
export var quantityHeader = "_gb-6";
export var tooltip = "_gb-1";
export var wrapAndEllipsesOverflow = "_gb-4";